// @flow
import React, { Component } from 'react';
import {connect} from 'react-redux';
import Particles from './Particles/ListExport';
import Remaining from './Particles/Remaining';
// import {applyConfiguration} from './actions';
import { Link } from 'react-router';
import {expandParticle, parentDimensions, setScrollPosY, setLanguage} from './actions';
import {Motion, spring} from 'react-motion';
import {throttle, debounce} from 'lodash';
import {gaEvent} from './actions/ga.js';
import {translate} from './actions/translate.js';

import './App.css';


let supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener("test", null, opts);
} catch (e) {}


const mapStateToProps = (state) => {
  return {
    opened: state.open,
    read: state.read,
    scrollPosY: state.scrollPosY,
    parentHeight: state.parentHeight,
  }
};

class App extends Component {

  constructor() {
    super();
    this.state = { straightened: false };
    this.handleScroll = this.handleScroll.bind(this);
    this.toggleRemaining = this.toggleRemaining.bind(this);
    this.expandRemaining = this.expandRemaining.bind(this);
    this.setDimensions = this.setDimensions.bind(this);
    this.straightenApp = this.straightenApp.bind(this);
  }

  componentWillMount(){
    const {lang='en'} = this.props.location.query;
    const guard = ['de', 'en'].indexOf(lang) > -1 ? lang : 'en';
    this.props.dispatch(setLanguage(guard));
    this.lang= guard;
    this.t = translate.bind(null, guard);
  }

  componentDidMount(){
    this.refs.App.addEventListener('scroll',
      throttle(this.handleScroll, 20), supportsPassive ? { passive: true } : false
    );
    window.addEventListener('resize',
      debounce(this.setDimensions, 20)
    );
  }

  setDimensions(){
    const {top, height} = this.refs.App.getBoundingClientRect();
    const clientHeight = this.refs.App.clientHeight;
    this.props.dispatch(parentDimensions(top, clientHeight || height));
  }

  straightenApp(){
    const {straightened} = this.state;
    if (!straightened) {
      this.setState({
        straightened: true
      });
    }
  }

  handleScroll(event){
    const {straightened} = this.state;
    const {scrollTop} = event.target;
    if (!straightened || event.target === window) {
      this.setDimensions();
      this.straightenApp();
    } else {
      this.props.dispatch(setScrollPosY(scrollTop));
    }
  }

  toggleRemaining(){
    this.setDimensions();
    const {toggleRemaining} = this.state;
    gaEvent( toggleRemaining ? 'hide' : 'show', 'Remaining');
    this.setState({toggleRemaining: !toggleRemaining});
  }

  expandRemaining( value, remove ){
    const {dispatch} = this.props;
    if (remove) {dispatch(expandParticle(value))};
    if (value && !remove) {gaEvent('open', 'Remaining-Particle', value)};
    this.setState({expandRemaining: value});
  }

  render() {
    const {straightened, toggleRemaining, expandRemaining} = this.state;
    const {read, parentHeight} = this.props;
    const {t, lang} = this;
    // const shareUrl = window.location + '?Particles=' + JSON.stringify(opened || null);

    return (
      <div className='Landing--Container'>
        <div className='Landing--Description'>
          <div>
            <h1>{t('intro title')}</h1>
            <p className='Landing--Description__intro'>
              {t('intro paragraph 1')}
            </p>
            <p>{t('intro paragraph 2')}</p>
            <p>{t('intro paragraph 3', 'https://goo.gl/forms/ufU4rFooAw6e9lRk1')}</p>
            <div className='Landing--Description__button-group'>
              <div className='Landing--Description__button' style={{opacity: straightened ? 0.2 : 1}} onClick={!straightened && this.handleScroll}>
                {t('button test prototype')}
              </div>
              <div className='Landing--Description__button ghost'>
                <Link to={{ pathname: '/docs', query: { lang: this.props.location.query.lang } }}>
                  {t('button link documentation')}
                </Link>
            </div>
            </div>
            <div className='Landing--Description__partner-group'>
              <a href='http://scitec-media.ch/'>
                <img src={require('./../public/logo_scitec-media.svg')} alt="Partner: Scitec Media"/>
              </a>
              <a href='https://www.interactivethings.com/'>
                <img src={require('./../public/logo_ixt_flag.svg')} alt="Partner: Interactive Things"/>
              </a>
            </div>
          </div>
          <a className='Landing--Description__supporter' href='https://www.digitalnewsinitiative.com'>
            <img src={require('./../public/Supporter.png')} alt="Supporter: Google Digital News Initiative"/>
          </a>
        </div>
        <div className={`App-device ${straightened ? 'App-device--straightened' : ''}`}>
          <div className='App' ref='App'>

            <div role='dialog' className={`App-modal ${straightened ? 'App-modal--straightened' : ''}`}>
              <h1>{t('intro title')}</h1>
              <p>{t('intro mobile text')}</p>
              <div className='Landing--Description__button-group'>
                <div className='Landing--Description__button' onClick={!straightened && this.handleScroll}>
                  {t('button test prototype')}
                </div>
                <div className='Landing--Description__button ghost'>
                  <Link to={{ pathname: '/docs', query: { lang: this.props.location.query.lang } }}>
                    {t('button link documentation')}
                  </Link>
                </div>
              </div>
            </div>

            <header role='banner' className='App-header'>
              <h1>{t('landing multicle title')}</h1>
            </header>

            <section className='App-content' role='main'>
              {Particles[1][lang].particle()}
            </section>

            <footer className='App-footer'>
              <div
                className='Remaining__action-button'
                onClick={this.toggleRemaining}>
                {t('landing remaining button')}
              </div>
              <a href='https://goo.gl/forms/ufU4rFooAw6e9lRk1'>
                {t('landing survey link')}
              </a>
            </footer>
          </div>
          <Motion defaultStyle={{left: 120}} style={{
            left: spring(toggleRemaining ? 0 : 120 )}} >
            { interpolated =>
              <div className='App-Remaining' style={{
                height: `${parentHeight}px`,
                transform: `translate3d(${interpolated.left}%, ${0}px, 0)`
              }}>
                <Remaining
                  toggleRemaining={this.toggleRemaining}
                  expandRemaining={this.expandRemaining}
                  expandedParticle={expandRemaining}
                  expanded={toggleRemaining}
                  read={read}
                  lang={lang}
                  height={parentHeight}
                  textRemaining={t('landing remaining header')}
                  textAllRead={t('landing remaining all read')}
                />
              </div>
            }
          </Motion>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/